import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import type { User } from '@dtwin/shared';

interface AuthState {
  user: User | null;
  token: string | null;
  isAuthenticated: boolean;
  login: (user: User, token: string) => void;
  logout: () => void;
  setUser: (user: User) => void;
  setToken: (token: string) => void;
}

const useAuthStore = create<AuthState>()(
  persist(
    (set) => ({
      user: null,
      token: typeof window !== 'undefined'
        ? localStorage.getItem('dtwin_token') || null
        : null,
      isAuthenticated: typeof window !== 'undefined'
        ? !!localStorage.getItem('dtwin_token')
        : false,
      login: (user, token) => {
        localStorage.setItem('dtwin_token', token);
        set({ user, token, isAuthenticated: true });
      },
      logout: () => {
        localStorage.removeItem('dtwin_token');
        set({ user: null, token: null, isAuthenticated: false });
      },
      setUser: (user) => set({ user }),
      setToken: (token: string) => {
        localStorage.setItem('dtwin_token', token);
        set({ token, isAuthenticated: true });
      },
    }),
    {
      name: 'dtwin-auth',
      partialize: (s) => ({ user: s.user }),
      merge: (persisted, current) => ({
        ...current,
        user: (persisted as { user?: User | null } | undefined)?.user ?? null,
      }),
    },
  ),
);

export default useAuthStore;
